export const getSchoolsOptions = (schools: any) =>
  schools.map((school: any) => ({
    label: school.name,
    value: school.id,
  }));

export const convertDataToApi = ({
  data,
  isRootAdmin,
  schoolId,
}: {
  data: any;
  isRootAdmin: any;
  schoolId: string;
}) => {
  if (isRootAdmin && data.school.value) {
    return {
      email: data.email.toLowerCase(),
      firstName: data.firstName,
      lastName: data.lastName,
      courses: data.courses,
      schoolId: data.school.value,
      isTest: data.isTest,
      isAdmin: data.isAdmin,
    };
  }

  return {
    email: data.email.toLowerCase(),
    firstName: data.firstName,
    lastName: data.lastName,
    courses: data.courses,
    schoolId,
    isTest: data.isTest,
    isAdmin: data.isAdmin,
  };
};
